const djz = {
    title: '店军师',
    logo: './static/img/logo.png',
    favicon: './static/favicon.ico'
}

const lianglimi = {
    title: '两粒米',
    logo: './static/img/lianglimi-logo.png',
    favicon: './static/lianglimi-favicon.ico'
}


export default djz




// WEBPACK FOOTER //
// ./src/oem/oem.js